<mat-card>
  <h2>Versionierung von HTML-Dokumente</h2>
  <mat-card-content>
    <p *ngIf="loading" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Dokumente werden geladen…</span>
    </p>
    <p *ngIf="error" class="error">{{ error }}</p>

    <div *ngIf="!loading && !error" class="document-types">
      <div *ngFor="let docType of documentTypes" class="document-row">
        <span class="doc-label">{{ label(docType) }}</span>
        <span class="doc-status">
          <ng-container *ngIf="getDocumentByType(docType) as doc">
            <button mat-raised-button (click)="editDocument(doc.getId())">Bearbeiten</button>
            <button mat-raised-button (click)="viewVersionHistory(doc.getId())">Versionshistorie</button>
          </ng-container>
          <ng-container *ngIf="!getDocumentByType(docType)">
            <button mat-raised-button color="primary" (click)="createDocument(docType)">Anlegen</button>
          </ng-container>
        </span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
